import type { VariantType } from '../../../types/variant';
import styles from './ToggleIconButton.module.scss';

export type ToggleIconButtonProps = {
  isActive: boolean;
  onClick: () => void;
  variant?: VariantType;
};

/**
 * goodsmileのみデザイン差分あり
 */
// biome-ignore lint/correctness/noUnusedVariables: <explanation>
function ToggleIconButton({ isActive, onClick, variant = 'default' }: ToggleIconButtonProps) {
  const currentStyles = styles;

  return (
    <button
      type='button'
      className={`${currentStyles.toggleIconButton} ${isActive ? currentStyles.active : ''}`}
      onClick={onClick}
      data-testid='menu-button'
    />
  );
}

export default ToggleIconButton;
